import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import OcurrenceLogRepository from '@/shared/http/repositories/realestate/occurencelog'

export default {
  name: 'logOcurrence',
  mixins: [ActionsForm, ExpenseMixin],
  props: {
    dataDetails: {
      type: Object,
      default: {}
    },
    logOcurrence: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    serachiput (newvalue) {
      this.logallfilter = this.logAll.filter((Element) => Element.titulo.toUpperCase().includes(newvalue.toUpperCase()))
    }
  },
  components: {HeadDetailsGama},
  data () {
    return {
      logAll: [],
      serachiput: '',
      logallfilter: [],
      checkUltimoLog: null,
      getLastLog: {},
      logRefresh: false
    }
  },
  mounted () {
    this.getLogById(this.dataDetails)
  },
  methods: {
    getLogById (e) {
      let id = e.id
      OcurrenceLogRepository.GetLogById(id)
        .then((res) => {
          this.logAll = res.data
          this.checkUltimoLog = this.logAll.filter(({ultimoLog}) => {
            return ultimoLog === true
          })
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/logOcorrence/logOcurrence.js